import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { auth } from '../../firebase';

export function RequireSuperAdmin({ children }) {
    const [loading, setLoading] = useState(true);
    const [isAuthorized, setIsAuthorized] = useState(false);

    useEffect(() => {
        const verifyAdminStatus = async () => {
            if (!auth.currentUser) {
                setIsAuthorized(false);
                setLoading(false);
                return;
            }

            try {
                // Force-refresh token to get the absolute newest claims immediately
                const idTokenResult = await auth.currentUser.getIdTokenResult(true);

                if (idTokenResult.claims && idTokenResult.claims.super_admin === true) {
                    setIsAuthorized(true);
                } else {
                    console.warn("User lacks super_admin custom claim.");
                    setIsAuthorized(false);
                }
            } catch (err) {
                console.error("Failed to verify super admin status:", err);
                setIsAuthorized(false);
            } finally {
                setLoading(false);
            }
        };

        verifyAdminStatus();
    }, []);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', alignItems: 'center', justifyContent: 'center' }}>
                <CircularProgress />
                <Typography sx={{ mt: 2, color: 'text.secondary' }}>Verifying admin privileges...</Typography>
            </Box>
        );
    }

    if (!isAuthorized) {
        return <Navigate to="/app" replace />;
    }

    return children;
}

export default RequireSuperAdmin;
